<template>
  <div class="wai">
    <div class="headWrap">

      <div :class="['card', menuNeedOpacity?'needOpacity':'']">
        <div class="menuCenter">
          <div v-if="isMobile()" href="###" class="logo_Mobile">
            <img :src="menuNeedOpacity?require('@/assets/images/logo.jpg'):require('@/assets/images/logo.png')" alt="" class="logoImg" />
          </div>
          <div v-else  href="###" class="logo">
            <img :src="menuNeedOpacity?require('@/assets/images/logo.jpg'):require('@/assets/images/logo.png')" alt="" class="logoImg" />
          </div>
          <div v-if="isMobile()"  @click="toggleMenu" >
            <el-button    type="text"  @click="drawer = true" class="button_Mobile" >
              <img  :src="menuNeedOpacity?require('@/assets/images/Menu1.png'):require('@/assets/images/Menu.png')" alt="" class="menuImg" style="height: 25px;margin-top: 50%"/>
            </el-button>
            <el-drawer title="东方地保" :visible.sync="drawer" width="500px" :direction="direction" :modal-append-to-body="false" customClass="customWidth" destroy-on-close @closed="$emit('closed')">
              <!--              <el-cascader :options="options" clearable></el-cascader>-->

            </el-drawer>

            <div class="search-wrapper " v-if="drawer" >
              <menu-Search
                  placeholder=""
                  v-model="searchKeyword"
              ></menu-Search>
            </div>

            <!--            <el-drawer title="东方地保" :visible.sync="drawer"-->
            <!--                       :direction="direction"-->
            <!--                       :append-to-body="true"-->
            <!--                       customClass="customWidth"-->
            <!--                       destroy-on-close @closed="$emit('closed')">-->
            <!--              <ul class="search-list" >-->
            <!--                <li  class="search-item">-->
            <!--                  <span >厦门</span></li>-->
            <!--                <li  class="search-item">-->
            <!--                  <span >三明</span></li>-->
            <!--              </ul>-->
            <!--              -->
            <!--            </el-drawer>-->


          </div>
          <div v-else v-for="item in navbarList"  :class="getLinkClass(item)"  >
            <router-link  :to="item.url" class="mLink" :style="{ color: navColor }">{{item.name}}</router-link>
          </div>

        </div>
      </div>
    </div>
    <!--    <div class="headBlank"></div>-->
  </div>
</template>

<script>
import search from '../search.vue'
import home, {getNavbar} from "@/api/home";

export default {
  name: 'pageTop',
  props: {
  },
  components: {
    search
  },
  data () {
    return {
      navColor: 'white', // 初始颜色为透明
      menuNeedOpacity: false,
      searchVisible: false,
      isShowView: false,
      // 初始LOGO图片URL
      logoUrl: require('@/assets/images/logo.png'),
      menuUrl: require('@/assets/images/Menu.png'),
      navbarList: [],
      drawerVisible: false, // 控制抽屉菜单的显示与隐藏
      drawer: false,
      direction: 'ttb',
      options: [{
        value: 'zhinan',
        label: '指南',
        children: [{
          value: 'shejiyuanze',
          label: '设计原则',
          children: [{
            value: 'yizhi',
            label: '一致'
          }, {
            value: 'fankui',
            label: '反馈'
          }, {
            value: 'xiaolv',
            label: '效率'
          }, {
            value: 'kekong',
            label: '可控'
          }]
        }, {
          value: 'daohang',
          label: '导航',
          children: [{
            value: 'cexiangdaohang',
            label: '侧向导航'
          }, {
            value: 'dingbudaohang',
            label: '顶部导航'
          }]
        }]
      }]
    }
  },
  mounted() {
    home.getNavbar('').then(rs => {
      this.navbarList=rs.data;
      console.log(rs)
    })
    window.addEventListener('scroll', this.handleScroll); // 在组件挂载后添加滚动事件监听器

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 组件销毁前移除事件监听器，避免内存泄漏
  },
  methods: {
    handleScroll() {
      // 根据滚动位置改变 navColor 的值
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 100) { // 例如，当滚动超过100px时改变颜色
        this.navColor = '#333'; // 滚动时的颜色
        this.menuNeedOpacity = true;

      } else {
        this.navColor = 'white'; // 返回顶部时的颜色
        this.menuNeedOpacity = false;

      }
    },
    showSearch(){
      this.isShowView=true
    },
    getLinkClass(item){
      if(this.isMobile()){
        if(this.$route.name===item.routeName){
          return "menuItem_Mobile cur"
        }
        return "menuItem_Mobile"
      }
      if(this.$route.name===item.routeName){
        return "menuItem cur"
      }
      return "menuItem"
    },
    toggleMenu() {
      this.drawerVisible = !this.drawerVisible; // 切换菜单的显示状态
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    }
  }
}
</script>

<style lang="less" scoped>
.wai {
  width: 100%;
  background-color: #333;
  .headWrap {
    height: 110px;
    width: 100%;
    position: fixed;
    z-index: 9;
    .headtop {
      width: 100%;
      height: 30px;
      background: #4e4e4e;
      .headtopCenter {
        height: 100px;
        //width: 1200px;
        margin: 0 auto;
        background: none;
        .left {
          height: 30px;
          line-height: 30px;
          width: auto;
          font-size: 12px;
          color: #f0f0f0;
          float: left;
        }
        .right {
          height: 30px;
          width: 300px;
          float: right;
          .bt {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #fff;
            float: right;
            margin-right: 10px;
          }
          .country {
            height: 30px;
            width: 100px;
            float: right;
            margin-left: 10px;
            .flag {
              display: block;
              height: 16px;
              float: left;
              margin: 7px 0 0 0;
            }
            .countryName {
              height: 30px;
              line-height: 30px;
              float: left;
              margin-left: 3px;
              font-size: 12px;
              color: #fff;
            }
          }
          .country:hover {
            cursor: pointer;
          }
        }
      }
    }
    .card {
      //height: 40px;
      margin-top: -105px;
      background-color: rgba(255, 255, 255, 0.2);/* 半透明背景 */
      backdrop-filter: blur(20px) /* 背景模糊 */
      saturate(180%);
      -webkit-backdrop-filter: blur(10px) saturate(180%);
      //border-radius: 10px;
      padding: 33px;
      text-align: center;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      .menuItem {
        //margin-top: -38px;
        float: right;
        padding: 0 20px;
        height: 66px;
        width: auto;
        top: 50%;
        transform: translate(-50%, -50%);

        .mLink {
          font-weight: bold;
          display: table-cell;
          height: 70px;
          vertical-align: middle;
          font-family: "等线";
          font-size: 15px; /* 设置基础字体大小为16像素，提升可读性 */
          line-height: 1.4; /* 设置较为舒适的行间距，1.6是一个常见且易读的选择 */
          letter-spacing: 0.2em; /* 使用em单位，相对于字体大小设置间距 */
          //display: block;
          padding: 8px 0;
          min-width: 80px;
          //height: 14px;
          text-decoration: none;
          //font-weight: bold;
          //margin-top: 30px;
        }

        .mLink:hover {
          color: #333;
        }
      }
      .button_Mobile{
        float: left;
        position: absolute;
        top: 40%;
        left: 10%;
        transform: translate(-50%, -50%);
        height: 100px;
      }
      .menuItem_Mobile {
        //margin-top: -38px;
        float: left;
        padding: 0 8px;
        height: 66px;
        width: auto;
        top: 50%;
        transform: translate(-50%, -50%);

        .mLink {
          font-weight: bold;
          display: table-cell;
          height: 70px;
          vertical-align: middle;
          font-family: "等线";
          font-size: 15px; /* 设置基础字体大小为16像素，提升可读性 */
          line-height: 1.4; /* 设置较为舒适的行间距，1.6是一个常见且易读的选择 */
          letter-spacing: 0.2em; /* 使用em单位，相对于字体大小设置间距 */
          //display: block;
          padding: 8px 0;
          min-width: 80px;
          //height: 14px;
          text-decoration: none;
          //font-weight: bold;
          //margin-top: 30px;
        }

        .mLink:hover {
          color: #333;
        }
      }
      .cur {
        background: rgba(255, 255, 255, 0.36);
        .mLink {
          color: #fff;
          //border-bottom: 2px solid #fff;
        }
      }
      /* 其他样式，如定位和尺寸 */
      //position: absolute;
      .logo {
        height: 46px;
        position: absolute;
        left: 6%;
        .logoImg {
          //opacity: 0.9;
          margin-top: -18px;
          display: block;
          height: 40px;
          //margin-top: -20px;
        }
      }
      .logo_Mobile {
        //height: 46px;
        //position: absolute;
        .logoImg{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 46px;
        }
        .menuImg{
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 16px;
        }

      }
    }

    .card h1 {
      color: #fff;
      text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .card p {
      color: #ddd;
    }
    .menu {
      margin-top: -100px;
      background-color: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(20px) /* 背景模糊 */ saturate(180%);
      -webkit-backdrop-filter: blur(10px) saturate(180%);
      border-radius: 10px;
      padding: 30px;
      max-width: 400px;
      text-align: center;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      //width: 100%;
      //height: 80px;
      //box-shadow: 0 0 75px 0 rgba(0,0,0,0.1);
      //background-color: rgba(0,0,0,0.1);
      //opacity: 1.9;
      .menuCenter {
        //height: 80px;
        //width: 1200px;
        /* 设置一个半透明的背景色，可选 */
        background-color: rgba(255, 255, 255, 0.1);

        /* 应用模糊效果 */
        backdrop-filter: blur(10px);



      }
    }
    .menu.needOpacity {
      opacity: 0.8;
    }
  }
  .headBlank {
    //height: 110px;
    //width: 100%;
  }
}
/* 设置激活状态下的 router-link 链接颜色 */
/* 设置默认的 router-link 链接颜色 */
.router-link {
  color: #333; /* 未激活时的颜色，例如深灰色 */
  text-decoration: none; /* 移除默认的下划线 */
}

/* 设置激活状态下的 router-link 链接颜色 */
.router-link-active {
  color: #333; /* 激活时的颜色，例如橙色 */
  text-decoration: none; /* 可选：保持无下划线，或根据需要调整 */
}
/deep/ .el-drawer__header {
  /* 修改标题容器的样式，例如颜色、字体大小等 */
  color: #333;
  font-size: 34px;
  font-weight: bold;
  text-align: center;
  display: grid;
  justify-items: center;
}

/deep/ .el-drawer__title span {
  /* 直接修改标题样式 */
  font-weight: bold;
  display: grid;
  justify-items: center;
  opacity: 0; /* 完全透明 */
}
/deep/ .el-icon{
  float: left;
}
/deep/ .el-drawer__close-btn {
  float: left;
  margin-left: -95%;
  margin-top: -36px;
  border: none;
  cursor: pointer;
  font-size: 28px;
  color: inherit;
  background-color: transparent;
}

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">-->
<!--  @import './pageTop.scss'-->
<!--</style>-->
